import {createStyles, Theme} from "@material-ui/core";
import {blueBackgroundColor, fullViewportColumn, styleColors, topCornerBend, topCornerMask} from "src/main.style";

export const SettingsContainerStyle = (theme: Theme) => createStyles({
  "@global": {
    ".settingsCard": {
      maxWidth: "695px",
      boxShadow: `0px 4px 4px ${styleColors.blackAlpha23}`,
      borderRadius: "12px",
      backgroundColor: styleColors.white,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      margin: "12px",
      padding: "36px 30px",
      gap: "30px",
      width: "calc(100% - 24px)",
      boxSizing: "border-box",
    },
    ".settingsPanel": {
      overflowX: "hidden",
      padding: "12px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      paddingBottom: "100px",
      backgroundColor: styleColors.greyLight2,
      alignItems: "center",
    },
    ".settingsPanelEnhancedVisibility": {
      fontSize: "17px",
    },
    ".settingsPanelEnhancedVisibility .settingsCard": {
      fontSize: "17px",
    },
    ".settingsPanelEnhancedVisibility .MuiTypography-body1": {
      fontSize: "17px",
    },
  },
  container : {
    ...fullViewportColumn,
    backgroundColor: blueBackgroundColor,
  },
  twoCards: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  mainText: {
    fontSize: '24px',
    margin: '0 0 8px 0',
  },
  acccountContainer: {
    display: 'flex',
    gap: '32px',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  accountItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    minWidth: 'calc(50% - 24px)',
    cursor: 'pointer',
  },
  screeningSetting: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    minWidth: 'calc(50% - 24px)',
  },
  screeningLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  downloadButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
  },
  screeningSelect: {
    minWidth: '180px',
  },
  filterHelpButton: {
    flexShrink: 0,
  },
  regionSelector: {
    marginLeft: '12px',
    display: 'flex',
    flexDirection: 'column'
  },
  headerButtons:{
    display: 'flex', 
    gap: '16px',
    margin: '16px'
  },
  containerTop : topCornerMask,
  containerCorners : topCornerBend(theme),
}
);



// WEBPACK FOOTER //
// ./src/containers/settings/settings.style.ts